import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  rootContainer: {
    marginTop: theme.spacing(1),
  },
}));
